import { Component } from '@theme/component';

class ThumbnailLoop extends Component {
  requiredRefs = ['thumbnailsContainer'];

  constructor() {
    super();
    this.currentIndex = 0;
    this.totalSlides = parseInt(this.refs.thumbnailsContainer.dataset.totalSlides, 10);
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Listen for thumbnail clicks
    this.refs.thumbnailsContainer.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('.slideshow-controls__thumbnail');
      if (thumbnail) {
        this.currentIndex = parseInt(thumbnail.dataset.index, 10);
      }
    });

    // Handle previous button
    const prevButton = this.querySelector('.slideshow-controls__thumbnails-previous');
    if (prevButton) {
      prevButton.addEventListener('click', () => this.navigatePrevious());
    }

    // Handle next button
    const nextButton = this.querySelector('.slideshow-controls__thumbnails-next');
    if (nextButton) {
      nextButton.addEventListener('click', () => this.navigateNext());
    }
  }

  navigatePrevious() {
    let newIndex = this.currentIndex - 1;
    if (newIndex < 0) {
      // Loop to the end
      newIndex = this.totalSlides - 1;
    }
    this.selectThumbnail(newIndex);
  }

  navigateNext() {
    let newIndex = this.currentIndex + 1;
    if (newIndex >= this.totalSlides) {
      // Loop to the beginning
      newIndex = 0;
    }
    this.selectThumbnail(newIndex);
  }

  selectThumbnail(index) {
    const thumbnails = this.querySelectorAll('.slideshow-controls__thumbnail');
    thumbnails.forEach((thumb) => {
      thumb.setAttribute('aria-selected', 'false');
    });

    const selectedThumb = thumbnails[index];
    if (selectedThumb) {
      selectedThumb.setAttribute('aria-selected', 'true');
      selectedThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      this.currentIndex = index;

      // Dispatch custom event for the slideshow to handle
      const event = new CustomEvent('thumbnail:selected', {
        detail: { index },
        bubbles: true
      });
      this.dispatchEvent(event);
    }
  }
}

if (!customElements.get('thumbnail-loop')) {
  customElements.define('thumbnail-loop', ThumbnailLoop);
}